// export const FikoYTQsStringifyOptions: IStringifyOptions = {
//     charset: "utf-8",
//     charsetSentinel: true,
//     skipNulls: false, strictNullHandling: true,
// }

/** BİLGİ: Http İsteklerinin Türkçeleştirilmiş Hali */
export enum IstekOlayTuru {
    Beklemede = -1,
    Istendi = 0,
    IlerlemeIstek = 1,
    BaslikCevap = 2,
    IlerlemeCevap = 3,
    Cevaplandi = 4,
    Ozel = 5,
    IptalEdildi = 6,
    Tamamlandi = 7
}

/** BİLGİ: Python(Server) Fiko Hata Sınıfını Buraya Taşıdım */
export interface FikoHata {
    kategori?: string;
    kod?: number;
    baslik?: string;
    mesaj?: string;
    sistemMesaji?: string;
}

export type FikoHatalar = Array<FikoHata>;

export interface IstekIlerleme {
    tipi: "UPLOAD" | "DOWNLOAD";
    toplam: number;
    durum: number;
    yuzde: number;
}

type DurumHatalarTipi = Array<FikoHata>;

export interface IstekDurum {
    hata?: boolean | null;
    hatalar?: DurumHatalarTipi;
    baslamaZamani?: Date | null;
    bitisZamani?: Date | null;
    mesgul?: boolean | null;
    tekrar?: number | null;
}

/** BİLGİ: Şimdilik Bir İşe Yaramıyor Ama Lazım Olur Diye Silmiyorum */
export interface IstekGiden {
    ismi: string;
    parametreler?: Array<any>;
    form?: any;
    kwargs?: any;
    json?: any;
}
/** NOT: Sonuc İstekleri Standarda Bağlanıyor */
export default interface IstekSonuc<T> {
    turu?: IstekOlayTuru;
    istekIlerleme?: IstekIlerleme;
    cevapIlerleme?: IstekIlerleme;
    durum?: IstekDurum;
    istek?: IstekGiden;
    sonuc?: T | any;
}